<template>
	<div class="d-inline-block w-100">
		<b-form-group v-if="length(options)" v-slot="{ ariaDescribedby }">
			<div @click="readOnlyAlert">
				<b-form-radio-group
					:id="context.id"
					v-model="selected"
					:options="options"
					:aria-describedby="ariaDescribedby"
					:class="context.classes"
					button-variant="primary"
					:disabled="isReadOnly"
					:name="context.name"
					@input="invalidDirty(context.id)" />
			</div>
		</b-form-group>

		<div v-if="showExplain && explainType !== 'notice'" class="yes-no-explanation">
			<FormulateInput
				v-if="explainType === 'input'"
				:name="context.name + '_explain'"
				:label="explainLabel"
				:help="explainHelp"
				outer-class="form-group"
				input-class="form-control"
				validation="required|max:240"
				validation-name="Explanation" />

			<FormulateInput
				v-if="explainType === 'boolean'"
				:name="context.name + '_explain'"
				:label="explainLabel"
				:help="explainHelp"
				type="radio"
				:options="{ yes: 'Yes', no: 'No' }"
				class="radio-inline"
				validation="required"
				validation-name="Confirmation" />

			<FormulateInput
				v-if="explainType === 'textarea'"
				:name="context.name + '_explain'"
				:label="explainLabel"
				:help="explainHelp"
				:debounce="500"
				type="textarea"
				outer-class="form-group"
				input-class="form-control"
				validation="required"
				validation-name="Explanation" />
		</div>

		<b-alert :show="showExplain === true && explainType === 'notice' && context.model !== ''" variant="warning">{{ explainLabel }}</b-alert>
	</div>
</template>
<script>
import _ from 'lodash'
import formInvalid from '@/Pages/Forms/Mixins/FormInvalid'

export default {
	mixins: [formInvalid],
	props: {
		context: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			selected: null
		}
	},
	computed: {
		showExplain () {
			if (this.context.hasOwnProperty('attributes')) {
				if (this.context.attributes.hasOwnProperty('explain_if')) {
					return this.selected === this.context.attributes.explain_if || this.selected && this.context.attributes.explain_if === 'any'
				}
			}

			return false
		},
		options () {
			const options = Object.assign({}, this.context.options)

			if (! this.length(options)) {
				return {
					'yes': 'Yes',
					'no': 'No'
				}
			}

			let selectOptions = {}
			for (const optionsKey in options) {
				if (!options.hasOwnProperty(optionsKey)) continue
				const option = options[optionsKey]
				if (! option.hasOwnProperty('value') && option.hasOwnProperty('label')) continue
				selectOptions[option.value] = option.label
			}

			if (! this.length(selectOptions)) {

				return {
					'yes': 'Yes',
					'no': 'No'
				}
			}

			return selectOptions
		},
		explainLabel () {
			if (this.context.hasOwnProperty('attributes')) {
				if (this.context.attributes.hasOwnProperty('explain_label')) {
					return this.context.attributes.explain_label
				}
			}

			return 'Please explain...'
		},
		explainType () {
			if (this.context.hasOwnProperty('attributes')) {
				if (this.context.attributes.hasOwnProperty('explain_type')) {
					return this.context.attributes.explain_type
				}
			}

			return 'input'
		},
		explainHelp () {
			if (this.context.hasOwnProperty('attributes')) {
				if (this.context.attributes.hasOwnProperty('explain_help')) {
					return this.context.attributes.explain_help
				}
			}

			return ''
		},
		/**
		 * Some answers are locked after a value is set.
		 */
		isReadOnly () {
			if (this.context.hasOwnProperty('attributes')) {
				if (! this.context.attributes.hasOwnProperty('locking')) {
					return false
				}
			}

			return this.context['attributes']['locking'] === true
				&& (this.selected !== null && this.selected !== '')
		}
	},
	watch: {
		selected: {
			handler: _.debounce(function (yesOrNo) {
				const required = _.find(this.context.rules, { 'ruleName': 'required' })
				if (required !== undefined) {
					const validationLabel = this.context.hasOwnProperty('validationName')
						? this.context.validationName
						: 'This'

					this.validateRequired(
						validationLabel,
						this.context.id,
						yesOrNo
					)
				}

				this.$set(this.context, 'model', yesOrNo)
			}, 100),
			deep: true
		},
		'context.classes' (newValue) {
			if (! newValue) {
				this.$set(this.context, 'classes', 'radio-inline mb-4')
			}
		}
	},
	mounted () {
		if (! this.context.classes) {
			this.$set(this.context, 'classes', 'radio-inline mb-4')
		}

		this.selected = this.context.model
	},
	beforeDestroy () {
		this.invalidReset(this.context.id)
	},
	methods: {
		readOnlyAlert () {
			if (this.isReadOnly) {
				this.$bvToast.toast('Your answer for that question cannot be changed. Please contact us if you need assistance.', {
					title: 'Locked',
					autoHideDelay: 12000,
					variant: 'danger',
					toaster: 'b-toaster-top-center mb-4'
				})
			}
		}
	}
}
</script>
